import React, { useState, useRef, useEffect   } from "react";
import { Link,useHistory} from "react-router-dom";
import { Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";

const RiderEarning = (props) => {
  const history=useHistory()
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  const [daily, setDaily] = useState(true);
  const [weekly, setWeekly] = useState(false);
  const [orders, setOrders] = useState([]);
  const [date, setDate] = useState("");
  const [searchData, setSearchData] = useState([]);
  const { id } = props.match.params;

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    axios.get(Baseurl.baseurl + `/rider/daily-orders/${id}`).then((res) => {
      setSpinner(false);
      setOrders(res.data.orders);
      setSearchData(res.data.orders);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  
  }, []);

  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  function searchRider(value) {
    if (searchData) {
      let filteredData = [];
      searchData.map((val) => {
        let phoneString = val.updatedAt.toString();
        if (
          val._id.toLowerCase().includes(value) ||
          val.PaymentType.toLowerCase().includes(value) ||
          val.OrderStatus.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setOrders(filteredData);
    }
  }
  function getDailyData() {
    setDaily(true);
    setWeekly(false);
    setSpinner(true);
    axios.get(Baseurl.baseurl + `/rider/daily-orders/${id}`).then((res) => {
      setSpinner(false);
      setOrders(res.data.orders);
      setSearchData(res.data.orders);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  function getWeeklyData() {
    setDaily(false);
    setWeekly(true);
    setSpinner(true);
    axios.get(Baseurl.baseurl + `/rider/weekly-orders/${id}`).then((res) => {
      setSpinner(false);
      setOrders(res.data.orders);
      setSearchData(res.data.orders);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  function getDateWiseData(val) {
    let date = new Date(val);
    setDate(val);
    setDaily(false);
    setWeekly(false);
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    axios
      .get(Baseurl.baseurl + `/rider/monthly-orders/${id}/${month}/${year}`)
      .then((res) => {
        setSpinner(false);
        setOrders(res.data.orders);
        setSearchData(res.data.orders);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  return (
    <div className="col-12">
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
        
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
        
          <button
            onClick={() => {
              getDailyData();
            }}
            className={daily ? "btn btn-success" : "btn btn-primary"}
          >
            Daily
          </button>
          <button
            onClick={() => {
              getWeeklyData();
            }}
            className={weekly ? "btn btn-success" : "btn btn-primary"}
          >
            Weekly
          </button>
          <input
            type="date"
            className="form-control col-sm-3"
            value={date}
            onChange={(e) => {
              getDateWiseData(e.target.value);
            }}
          ></input>
          <button className="btn btn-primary" onClick={()=>{history.goBack()}}>Back</button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper ">
              {spinner ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <table
                  className="display w-100 dataTable  "
                  id="myTable"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Order ID
                      </th>

                      <th className="text-white" rowSpan="1" colSpan="1">
                        Payment Type
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Order Status
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Date
                      </th>
                      <th className="text-white" rowSpan="1" colSpan="1">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {orders &&
                      orders.map((order) => (
                        <tr className="odd" role="row" key={order._id}>
                          <td className="sorting_1">{order._id}</td>

                          <td>{order.PaymentType}</td>
                          <td>{order.OrderStatus}</td>
                          <td>{order.updatedAt}</td>
                          <td>
                            <Link to="/show-order">
                              <button
                                onClick={() => {
                                  localStorage.setItem("orderId", order._id);
                                }}
                                className="btn btn-primary"
                              >
                                View
                              </button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
              {!orders && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Zero Orders
                </Alert>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                <div className="dataTables_info text-white">
                  Showing {activePag.current * sort + 1} to{" "}
                  {data.length > (activePag.current + 1) * sort
                    ? (activePag.current + 1) * sort
                    : data.length}{" "}
                  of {data.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers"
                  id="example5_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    onClick={() =>
                      activePag.current > 0 && onClick(activePag.current - 1)
                    }
                  >
                    Previous
                  </Link>
                  <span>
                    {paggination.map((number, i) => (
                      <Link
                        key={i}
                        className={`paginate_button  ${
                          activePag.current === i ? "current" : ""
                        } `}
                        onClick={() => onClick(i)}
                      >
                        {number}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    onClick={() => {
                      activePag.current + 1 < paggination.length &&
                        onClick(activePag.current + 1);
                    }}
                  >
                    Next
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiderEarning;
